__turbopack_context__.v({
  "shimmer": "vIzRtW_shimmer",
  "slot": "vIzRtW_slot",
  "slot__future": "vIzRtW_slot__future",
  "slot__icon": "vIzRtW_slot__icon",
  "slot__live": "vIzRtW_slot__live",
  "slot__past": "vIzRtW_slot__past",
  "slot__today": "vIzRtW_slot__today",
  "slot__tomorrow": "vIzRtW_slot__tomorrow",
  "text-bar-sweep": "vIzRtW_text-bar-sweep",
});
